import {
  DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_BEGIN,
  DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_SUCCESS,
  DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_FAILURE,
  DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export function getMySqlExternalDb(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_BEGIN,
    });
    const { version, projectId, dbUuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/mysql/externalDb/${dbUuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_SUCCESS,
            data: res.data.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetMySqlExternalDbError() {
  return {
    type: DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getMySqlExternalDbPending: true,
        getMySqlExternalDbError: null,
      };

    case DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_SUCCESS:
      // The request is success
      return {
        ...state,
        getMySqlExternalDbPending: false,
        getMySqlExternalDbError: null,
        mysqlStoredData: action.data,
      };

    case DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_FAILURE:
      // The request is failed
      return {
        ...state,
        getMySqlExternalDbPending: false,
        getMySqlExternalDbError: action.data.error,
      };

    case DATA_CONNECTOR_GET_MY_SQL_EXTERNAL_DB_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getMySqlExternalDbError: null,
      };

    default:
      return state;
  }
}
